import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Eye, Pencil, Printer } from "lucide-react";
import { formatDate } from "@/lib/date";
import { PrescriptionViewDialogBody } from "@/components/patient-tabs/PrescriptionViewDialogBody";

// "Prescription History" tab — list of saved prescriptions + a read-only View
// dialog (with quick Edit/Print actions inside). Data/state owned by parent.
export default function PatientPrescriptionHistoryTab({ prescriptions, viewingPrescription, setViewingPrescription, navigate }) {
  return (
    <>
      <div className="card-surface card-surface-hover rounded-xl border border-slate-200 bg-white shadow-sm p-6">
        <h2 className="font-semibold text-slate-900">Prescription History</h2>
        <div className="mt-4 space-y-3">
          {prescriptions.map((p) => (
            <div key={p.id} className="flex items-center justify-between rounded-lg border border-slate-200 p-3" data-testid={`prescription-row-${p.id}`}>
              <div>
                <p className="text-sm text-slate-900">{formatDate(p.created_at)} · {p.medicines.length} medicines</p>
                <p className="text-xs text-slate-500">{p.doctor_name}{p.last_edited_at && <span className="italic"> · edited {formatDate(p.last_edited_at)}</span>}</p>
              </div>
              <div className="flex items-center gap-2">
                <Button size="sm" variant="outline" className="gap-2" data-testid={`view-prescription-btn-${p.id}`} onClick={() => setViewingPrescription(p)}>
                  <Eye className="h-4 w-4" /> View
                </Button>
                <Button size="sm" variant="outline" className="gap-2" data-testid={`edit-prescription-btn-${p.id}`} onClick={() => navigate(`/doctor/prescriptions/${p.id}/edit`)}>
                  <Pencil className="h-4 w-4" /> Edit
                </Button>
                <Button size="sm" variant="outline" className="gap-2" data-testid={`print-prescription-btn-${p.id}`} onClick={() => navigate(`/doctor/prescriptions/${p.id}/print`)}>
                  <Printer className="h-4 w-4" /> Print
                </Button>
              </div>
            </div>
          ))}
          {prescriptions.length === 0 && <p className="text-sm text-slate-400">No prescriptions saved yet.</p>}
        </div>
      </div>

      <Dialog open={!!viewingPrescription} onOpenChange={(open) => !open && setViewingPrescription(null)}>
        <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="view-prescription-dialog">
          {viewingPrescription && <PrescriptionViewDialogBody prescription={viewingPrescription} navigate={navigate} />}
        </DialogContent>
      </Dialog>
    </>
  );
}
